type ReturnLocation = {
  pathname?: unknown;
  search?: unknown;
  hash?: unknown;
};

const blockedPublicPath = /^\/(?:login|register|forgot-password|reset-password)(?:[/?#]|$)/;

const hasControlCharacter = (value: string) =>
  Array.from(value).some(character => {
    const codePoint = character.codePointAt(0) ?? 0;
    return codePoint <= 31 || codePoint === 127;
  });

export const safeReturnPath = (value: unknown): string | null => {
  let candidate: string | null = null;
  if (typeof value === 'string') {
    candidate = value;
  } else if (value && typeof value === 'object') {
    const location = value as ReturnLocation;
    if (typeof location.pathname === 'string') {
      candidate = `${location.pathname}${
        typeof location.search === 'string' ? location.search : ''
      }${typeof location.hash === 'string' ? location.hash : ''}`;
    }
  }

  if (
    !candidate ||
    !candidate.startsWith('/') ||
    candidate.startsWith('//') ||
    candidate.includes('\\') ||
    hasControlCharacter(candidate) ||
    blockedPublicPath.test(candidate)
  ) {
    return null;
  }
  return candidate;
};
